export function getTimeFormat() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      showHour = _ref.showHour,
      showMinute = _ref.showMinute,
      showSecond = _ref.showSecond;

  var formatStr = '';
  if (showHour) formatStr += '00';
  if (showMinute) formatStr += ':00';
  if (showSecond) formatStr += ':00';
  if (formatStr.split(':').length === 1) return '00:00';
  return formatStr;
}